<template>
  <div id="basketball_teamRank">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        @changeSelectEvent="changeSelect"
      ></marathon_select_opt>
    </div>
    <div class="group_box" ref="tableParentDom">
      <template v-if="groupTable">
        <div
          class="group_item"
          v-for="(group, groupIndex) in groupTable"
          :key="groupIndex"
        >
          <span
            v-if="groupTable && groupTable.length > 1"
            class="group_title"
            v-text="group.groupTitle"
          ></span>
          <div class="table_container">
            <nodeTree_table
              :currThemeObj="currThemeObj"
              :currCid="currCid"
              :currSid="currSid"
              :tableMode="tableMode"
              :parentWidthPx="parentWidthPx"
              :isScrollFlag="isScrollFlag"
              :isClickFlag="isClickFlag"
              :variableColWidthVw="variableColWidthVw"
              :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
              :defaultWidthVwNum="defaultWidthVwNum"
              :tableColumnData="tableColumnData"
              :tableData="group.tableData"
              :tableHeightPx="0"
              :rowClassName="rowClassNameFun"
              :jumpRouterPathNames="jumpRouterPathNames"
              :rankingStyles="group.rankingStyles"
              v-show="group.tableData && group.tableData.length > 0"
            ></nodeTree_table>
            <span
              v-if="themeItem"
              class="cup_table_publishBtn"
              @click="clickPublish(themeItem, group)"
            >
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="50%"
                height="50%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span>
          </div>
          <span class="tagsTipArr">
            <span
              class="tagsItem"
              v-for="tags in group.rankingStyles"
              :key="tags.styleId"
            >
              <span
                class="tagsItemColor"
                :style="{ backgroundColor: `#${tags.barColor}` }"
              ></span>
              <span class="tagsItemName" v-text="tags.description"></span>
            </span>
          </span>
        </div>
      </template>
      <cup_notData
        v-show="groupTable && groupTable.length === 0"
        className="relativePtb60"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import {
  https_basketball_teamRankSeasonList,
  https_teamRankList,
} from '@api/platfrom_basketball_api'

import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'

export default {
  name: 'basketball_teamRank',
  components: { marathon_select_opt, nodeTree_table, cup_notData },
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  data() {
    return {
      themeTemplateTypeArr: [21, 4],
      themeTemplateType: 21,
      themeItem: null,
      loading: false,
      tableMode: 'teamData leagueCBA',
      jumpRouterPathNames: {
        pathName_teamDetail: 'teamDetailIndex',
        pathName_playerDetail: '',
      },
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 13.88,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      groupTable: null,
      currStageSeason: '',
      currStageRankType: '', //联赛和赛区同时出现时，多一个下拉框
      selectAllObj: {
        value: 'all',
        name: '全部',
      },
      seasonArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'season',
            title: '赛季',
            origin_keyVal: ['seasonId', 'seasonName'],
            dataName: 'seasonArr',
            selectIndex: 0,
            isFilterable: true,
          },
        ],
        selectOpt_list: [],
      },
      dynamicJson: ['conferenceId', 'divisionId'],
    }
  },
  created() {
    this.browserType = this.isBrowser()
    if (this.browserType === 'safari') {
      this.browserClassName = 'safari_css'
    } else {
      this.browserClassName = 'common_css'
    }
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: '',
      }
    }
    console.debug('this.browserType:', this.browserType)
    if (this.currGroup) {
      this.init()
    }
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug(
      'this.parentWidthPx:',
      this.$refs.tableParentDom.scrollHeight,
      this.parentWidthPx
    )
  },
  computed: {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      const sportTypeArr = ['basketball', 'football']
      if (this.currThemeObj) {
        const index = sportTypeArr.indexOf(this.currThemeObj.sportType)
        this.themeTemplateType = this.themeTemplateTypeArr[index]
      }
      await this.getSeasonList()
      this.computedSelectOpt(this.selectOptData.configArr)
      await this.getTeamRankData()
      this.makeAnalysisItemParams(this.themeTemplateType)
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    makeAnalysisItemParams(themeTemplateType) {
      // 每个页面单独设置不同函数
      console.debug('makeAnalysisItemParams')
      this.findAnalysisItemParams = {
        sportType: 'basketball',
        templateType: themeTemplateType,
        cid: this.currCid,
        sid: this.currSid,
        did: 0,
        eid: 0,
        pid: 0,
        mid: 0,
      }
      if (this.initSingleFindAnalysisItem) {
        this.initSingleFindAnalysisItem(this.findAnalysisItemParams)
      }
      // let { num } = this.paramsChangeObj
      // this.paramsChangeObj = {
      //   type: 'reset',
      //   num: num + 1,
      // }
    },
    findAnalysisItemCallback(resData) {
      // 主题数据和主题分析项分开，分析项有数据后展示分享按钮
      let jsonArr = []
      if (resData && resData.length > 0) {
        this.themeList = resData.map((item) => {
          jsonArr.push(item.json)
          item.actJson = JSON.parse(item.json)
          item.renderData = null
          return item
        })
        this.themeItem = this.themeList[0]
      } else {
        this.themeList = []
        this.themeItem = null
      }
    },
    computedSelectOpt(configArr) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        let list = []
        if (config.isDatePicker) {
          // 日期选择框没有 dataName 属性
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: mix_id, //list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: this.currStageMatchDate ? this.currStageMatchDate : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr,
            list,
            isDatePicker: config.isDatePicker,
          })
        } else {
          list = this[config.dataName].map((item) => {
            item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
            return item
          })
          console.debug(
            'computedSelectOpt:',
            config.dataName,
            this[config.dataName],
            list,
            mix_id
          )
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[config.selectIndex][mix_id], // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[config.selectIndex][config.origin_keyVal[1]], // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            isFilterable: config.isFilterable ? config.isFilterable : false,
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'season') {
            this.currStageSeason = valPathArr[1]
            // this.computedSelectOpt(this.selectOptData.configArr)
          } else {
          }
          // 筛选表格逻辑
          this.getTeamRankData()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    clickPublish(themeItem, groupItem) {
      if (!themeItem) return
      // 分享主题
      let keyArrActJson = []
      let dynamicIndex = 0
      let newThemeItem = JSON.parse(JSON.stringify(themeItem))
      newThemeItem.actJson = JSON.parse(newThemeItem.json)
      keyArrActJson = Object.keys(newThemeItem.actJson)
      newThemeItem.actJson[keyArrActJson[0]] = this.currStageSeason
      // cba conferenceId
      newThemeItem.actJson[this.dynamicJson[dynamicIndex]] =
        groupItem[this.dynamicJson[dynamicIndex]]
      console.debug('newThemeItem:', themeItem, newThemeItem, keyArrActJson)
      if (!newThemeItem.analysisItemName) {
        // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
        newThemeItem.analysisItemName = newThemeItem.title
      }
      this.clickPublicTheme(newThemeItem)
    },
    // clickPublicTheme(themeItem, groupItem) {
    //   if (!themeItem) return
    //   // 分享主题
    //   let keyArrActJson = []
    //   let dynamicIndex = 0
    //   let newThemeItem = JSON.parse(JSON.stringify(themeItem))
    //   newThemeItem.actJson = JSON.parse(newThemeItem.json)
    //   keyArrActJson = Object.keys(newThemeItem.actJson)
    //   newThemeItem.actJson[keyArrActJson[0]] = this.currStageSeason
    //   // cba conferenceId
    //   newThemeItem.actJson[this.dynamicJson[dynamicIndex]] =
    //     groupItem[this.dynamicJson[dynamicIndex]]
    //   console.debug('newThemeItem:', themeItem, newThemeItem, keyArrActJson)
    //   if (!newThemeItem.analysisItemName) {
    //     // 有的主题有analysisItemName，有的没有，比如积分榜，因此处理一下，分享主题到公共播单的接口dataItemName都取这个字段
    //     newThemeItem.analysisItemName = newThemeItem.title
    //   }
    //   window.mixtmtBase_eventBus.$emit('publicThemeDialogEvent', {
    //     flag: true,
    //     themeItem: newThemeItem,
    //   })
    // },
    rowClassNameFun({ row, rowIndex }) {
      // console.debug("rowClassNameFun:", row,rowIndex)
      var className = ''
      this.tableRankLineArr.forEach((lineItem, lineIndex) => {
        // type: true 实线; false: 虚线
        let borderType = lineItem.type
          ? `border_solid ${this.browserClassName}`
          : `border_dashed ${this.browserClassName}`
        if (lineIndex === 0 && rowIndex < lineItem.index) {
          if (lineItem.index - 1 === rowIndex) {
            className = `basketballLeague_teamRank rankNumSubColor1_1 borderBottom ${borderType}`
          } else {
            className = 'basketballLeague_teamRank rankNumSubColor1_1'
          }
        } else {
          if (lineItem.index - 1 === rowIndex) {
            className = `basketballLeague_teamRank borderBottom ${borderType}`
          }
        }
      })
      return className
    },
    async getSeasonList() {
      await https_basketball_teamRankSeasonList(
        this.axiosBaseUrl,
        this.$axios,
        {
          cid: this.currCid,
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.seasonArr =
              res.data &&
              res.data[0].values.map((item) => {
                return {
                  seasonId: item.value,
                  seasonName: item.name,
                }
              })
            this.currStageSeason = this.seasonArr[0].seasonId
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getTeamRankData() {
      await https_teamRankList(this.axiosBaseUrl, this.$axios, {
        sid: this.currStageSeason,
        // rankType: this.currStageRankType
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data.datas && res.data.datas.length > 0) {
              if (res.data.middle && res.data.middle.length) {
                console.debug('this.groupTable:', this.groupTable, res)
                const leftColumns = res.data.left
                const middleColumns = res.data.middle.map((columItem) => {
                  let item = columItem
                  if (item.colKey === 'lastSix') {
                    item.colKey = 'teamRank_lastFive_record'
                  }
                  return item
                })
                const rightColumns = res.data.right

                this.defaultWidthVwNum = res.data.middle.length
                if (this.tableColumnData.length == 0) {
                  let tableColumnData = []
                  let leftColumnObjArr = []
                  let rightColumnObjArr = []
                  if (leftColumns) {
                    for (let i = 0; i < leftColumns.length; i++) {
                      leftColumnObjArr.push({
                        prop: 'rankNum-teamLogo-teamName', //fristColumnPropArr.join('-'),
                        label: '球队',
                        widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                        className: 'rankNum-teamLogo-teamName', //单独定制的头部样式class
                        fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                      })
                    }
                  }

                  tableColumnData = [].concat(leftColumnObjArr)
                  for (let i = 0; i < middleColumns.length; i++) {
                    const item = middleColumns[i]
                    let tableCellDefaultWidthVw = this.tableCellDefaultWidthVw
                    if (item.colKey === 'teamRank_lastFive_record') {
                      tableCellDefaultWidthVw = 9
                    }
                    tableColumnData.push({
                      prop: item.colKey,
                      label: item.colTitle,
                      widthVw: tableCellDefaultWidthVw, //对应列的宽度，单位vw
                      className: '', //单独定制的头部样式class
                      selected: item.selected,
                    })
                  }
                  tableColumnData.push({
                    prop: '',
                    label: '',
                    widthVw: 3.74,
                    selected: false,
                  })

                  if (rightColumns) {
                    for (let i = 0; i < rightColumns.length; i++) {
                      rightColumnObjArr.push({
                        prop: 'leftTeamName', //fristColumnPropArr.join('-'),
                        label: '球队',
                        widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                        className: 'columnTeamNameClass', //单独定制的头部样式class
                        fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                      })
                    }
                  }

                  this.tableColumnData = [].concat(
                    tableColumnData,
                    rightColumnObjArr
                  )
                }
              }
              this.groupTable = res.data.datas.map((group) => {
                // this.tableRankLineArr = [
                //   { index: 4, type: false },
                //   { index: 12, type: true },
                // ]
                this.tableRankLineArr = group.rankLines
                return {
                  groupTitle: group.groupName ? group.groupName : '',
                  conferenceId:
                    group.teamsRank &&
                    group.teamsRank[0] &&
                    group.teamsRank[0][this.dynamicJson[0]]
                      ? group.teamsRank[0][this.dynamicJson[0]]
                      : '',
                  divisionId:
                    group.teamsRank &&
                    group.teamsRank[0] &&
                    group.teamsRank[0][this.dynamicJson[1]]
                      ? group.teamsRank[0][this.dynamicJson[1]]
                      : '',
                  tableData: group.teamsRank
                    ? group.teamsRank.map((row) => {
                        row.rankNum = row.groupRank
                        if (row.lastSix) {
                          if (row.lastSix.length > 5) {
                            row.teamRank_lastFive_record =
                              row.lastSix.substring(0, 5)
                          } else {
                            row.teamRank_lastFive_record = row.lastSix
                          }
                        }
                        return row
                      })
                    : [],
                  rankingStyles: group.rankingStyles
                    ? group.rankingStyles
                    : null,
                }
              })

              console.debug(
                'this.groupTable:',
                this.groupTable,
                this.tableColumnData
              )
            } else {
              this.groupTable = []
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_teamRank {
  width: 100%;
  .select_area {
    padding: 2.083vw 0;
  }
  .group_box {
    width: 100%;
    padding-bottom: 2.778vw;
    height: auto;
    .group_item {
      width: 100%;
      padding-top: 1.388vw;
      &:first-child {
        padding-top: 0;
      }
    }
    .group_title {
      display: block;
      padding-bottom: 1.388vw;
      line-height: 1.388vw;
      font-size: 1.11vw;
      color: var(--mixtmt_greyColor3);
      font-weight: bold;
    }
    .table_container {
      position: relative;
      .cup_table_publishBtn {
        position: absolute;
        right: 0;
        top: 0;
        z-index: 2;
        width: 4.16vw;
        height: 3.332vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        svg.publishBtn_icon {
          fill: var(--mixtmt_table_publicBtnColor);
        }
      }
    }
    .tagsTipArr {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      padding: 1.38vw 0;
      .tagsItem {
        width: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        padding-right: 1.38vw;
        .tagsItemColor {
          width: 1.11vw;
          height: 1.11vw;
          border-radius: 0.347vw;
        }
        .tagsItemName {
          width: auto;
          padding: 0 0.416vw;
          font-size: 0.974vw;
          color: var(--mixtmt_greyColor3);
        }
      }
    }
  }
}

.mixtmt_pc #basketball_teamRank {
  .cup_table_publishBtn {
    cursor: pointer;
    &:hover {
      svg.publishBtn_icon {
        fill: var(--mixtmt_subColor1_1);
      }
    }
  }
}
</style>
